import Vue from "vue";
import Vuex from "vuex";

import common from "./modules/common";
import tally from "./modules/tally";
import getters from "./getters";

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        common,
        tally
    },
    getters
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js